export enum ContentAlign {
  LEFT = "left",
  RIGHT = "right",
  CENTER = "center",
}

export enum ContentComponent {
  ACCORDION_LIST = "accordionList",
  ADVANTAGES_LIST = "advantagesList",
  CHECKMARK_LIST = "checkmarkList",
  ICON_LIST = "iconList",
  HERO = "leading",
  SIMPLIFIED_HERO = "simplifiedLeading",
  SIMPLE_TEXT = "simpleText",
  SIMPLE_IMAGE = "simpleImage",
  SIDE_IMAGE = "sideImage",
  DOUBLE_IMAGE = "doubleImage",
  BENEFITS = "benefits",
  DOWNLOAD_APP = "downloadApp",
  DOWNLOAD_FILE = "downloadFile",
  FAQ = "questions",
  MANDATES = "mandates",
  MULTITEXT_IMAGE = "multitextImage",
  NEIGHBOUR_IMAGE = "neighbourImages",
  REVIEWS = "reviews",
  TABLE = "simpleTable",
  CARDS = "cards",
  TWO_COLUMNS_LIST = "twoColumnsList",
  SIMPLE_TWO_COLUMNS_LISTS = "simpleTwoColumnsLists",
  CURRENCY_CONVERTER = "currencyConverter",
  CURRENCY_CONVERTER_CHART = "currencyConverterChart",
  IMAGE_CAROUSEL = "imageCarousel",
  CONTEST_CONTACT = "contestContact",
  PERFORMANCE_GRAPHS = "performanceGraphs",
  AMBASSADORS = "ambassadors",
  SWITCH_CURRENCIES = "switchCurrencies",
  SIMPLE_CONTACT = "simpleContactForm",
  ICON_CARDS_LIST = "iconCardsList",
  SIDE_IMAGE_SLIDES = "sideImageSlides",
  FAQ_LIBRARY = "faqLibrary",
  CARDS_CAROUSEL = "cardsCarousel",
  PLANS = "plans",
  COLUMNS_TEXT = "columnsText",
  TAB_SLIDE_SWITCHER = "tabSlideSwitcher",
  IMAGE_TITLE = "imageTitle",
  IMAGE_REVIEWS = "imageReviews",
  ICON_BOXES = "iconBoxes",
}

export enum Size {
  SMALL = "s",
  LARGE = "l",
}

export enum ViewVariant {
  FULL_WIDTH = "fullWidth",
  CONTAINER = "container",
}
